/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { CollectionNestedOption } from '../../../core/nested-option';

import DevExpress from 'devextreme/bundles/dx.all';

export abstract class DxiContextMenuItem extends CollectionNestedOption {
    get disabled(): boolean {
        return this._getOption('disabled');
    }
    set disabled(value: boolean) {
        this._setOption('disabled', value);
    }

    get html(): string {
        return this._getOption('html');
    }
    set html(value: string) {
        this._setOption('html', value);
    }

    get icon(): string {
        return this._getOption('icon');
    }
    set icon(value: string) {
        this._setOption('icon', value);
    }

    get iconSrc(): string {
        return this._getOption('iconSrc');
    }
    set iconSrc(value: string) {
        this._setOption('iconSrc', value);
    }

    get template(): any {
        return this._getOption('template');
    }
    set template(value: any) {
        this._setOption('template', value);
    }

    get text(): string {
        return this._getOption('text');
    }
    set text(value: string) {
        this._setOption('text', value);
    }

    get title(): string {
        return this._getOption('title');
    }
    set title(value: string) {
        this._setOption('title', value);
    }

    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    get onClick(): Function|
        string {
        return this._getOption('onClick');
    }
    set onClick(value: Function|
        string) {
        this._setOption('onClick', value);
    }

    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    get baseSize(): number|
        string {
        return this._getOption('baseSize');
    }
    set baseSize(value: number|
        string) {
        this._setOption('baseSize', value);
    }

    get box(): DevExpress.ui.dxBoxOptions {
        return this._getOption('box');
    }
    set box(value: DevExpress.ui.dxBoxOptions) {
        this._setOption('box', value);
    }

    get ratio(): number {
        return this._getOption('ratio');
    }
    set ratio(value: number) {
        this._setOption('ratio', value);
    }

    get beginGroup(): boolean {
        return this._getOption('beginGroup');
    }
    set beginGroup(value: boolean) {
        this._setOption('beginGroup', value);
    }

    get closeMenuOnClick(): boolean {
        return this._getOption('closeMenuOnClick');
    }
    set closeMenuOnClick(value: boolean) {
        this._setOption('closeMenuOnClick', value);
    }

    get items(): any|
        Array<any|
        DevExpress.ui.dxFormSimpleItem|
        DevExpress.ui.dxFormGroupItem|
        DevExpress.ui.dxFormTabbedItem|
        DevExpress.ui.dxFormEmptyItem> {
        return this._getOption('items');
    }
    set items(value: any|
        Array<any|
        DevExpress.ui.dxFormSimpleItem|
        DevExpress.ui.dxFormGroupItem|
        DevExpress.ui.dxFormTabbedItem|
        DevExpress.ui.dxFormEmptyItem>) {
        this._setOption('items', value);
    }

    get selectable(): boolean {
        return this._getOption('selectable');
    }
    set selectable(value: boolean) {
        this._setOption('selectable', value);
    }

    get selected(): boolean {
        return this._getOption('selected');
    }
    set selected(value: boolean) {
        this._setOption('selected', value);
    }

    get colSpan(): number {
        return this._getOption('colSpan');
    }
    set colSpan(value: number) {
        this._setOption('colSpan', value);
    }

    get cssClass(): string {
        return this._getOption('cssClass');
    }
    set cssClass(value: string) {
        this._setOption('cssClass', value);
    }

    get dataField(): string {
        return this._getOption('dataField');
    }
    set dataField(value: string) {
        this._setOption('dataField', value);
    }

    get editorOptions(): any {
        return this._getOption('editorOptions');
    }
    set editorOptions(value: any) {
        this._setOption('editorOptions', value);
    }

    get editorType(): string {
        return this._getOption('editorType');
    }
    set editorType(value: string) {
        this._setOption('editorType', value);
    }

    get helpText(): string {
        return this._getOption('helpText');
    }
    set helpText(value: string) {
        this._setOption('helpText', value);
    }

    get isRequired(): boolean {
        return this._getOption('isRequired');
    }
    set isRequired(value: boolean) {
        this._setOption('isRequired', value);
    }

    get itemType(): string {
        return this._getOption('itemType');
    }
    set itemType(value: string) {
        this._setOption('itemType', value);
    }

    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    get name(): string {
        return this._getOption('name');
    }
    set name(value: string) {
        this._setOption('name', value);
    }

    get validationRules(): Array<DevExpress.ui.RequiredRule|
        DevExpress.ui.NumericRule|
        DevExpress.ui.RangeRule|
        DevExpress.ui.StringLengthRule|
        DevExpress.ui.CustomRule|
        DevExpress.ui.CompareRule|
        DevExpress.ui.PatternRule|
        DevExpress.ui.EmailRule> {
        return this._getOption('validationRules');
    }
    set validationRules(value: Array<DevExpress.ui.RequiredRule|
        DevExpress.ui.NumericRule|
        DevExpress.ui.RangeRule|
        DevExpress.ui.StringLengthRule|
        DevExpress.ui.CustomRule|
        DevExpress.ui.CompareRule|
        DevExpress.ui.PatternRule|
        DevExpress.ui.EmailRule>) {
        this._setOption('validationRules', value);
    }

    get visibleIndex(): number {
        return this._getOption('visibleIndex');
    }
    set visibleIndex(value: number) {
        this._setOption('visibleIndex', value);
    }

    get alignItemLabels(): boolean {
        return this._getOption('alignItemLabels');
    }
    set alignItemLabels(value: boolean) {
        this._setOption('alignItemLabels', value);
    }

    get caption(): string {
        return this._getOption('caption');
    }
    set caption(value: string) {
        this._setOption('caption', value);
    }

    get colCount(): number {
        return this._getOption('colCount');
    }
    set colCount(value: number) {
        this._setOption('colCount', value);
    }

    get colCountByScreen(): any {
        return this._getOption('colCountByScreen');
    }
    set colCountByScreen(value: any) {
        this._setOption('colCountByScreen', value);
    }

    get tabPanelOptions(): DevExpress.ui.dxTabPanelOptions {
        return this._getOption('tabPanelOptions');
    }
    set tabPanelOptions(value: DevExpress.ui.dxTabPanelOptions) {
        this._setOption('tabPanelOptions', value);
    }

    get tabs(): Array<any|
        { alignItemLabels?: boolean, badge?: string, colCount?: number, colCountByScreen?: { lg?: number, md?: number, sm?: number, xs?: number }, disabled?: boolean, icon?: string, items?: Array<DevExpress.ui.dxFormSimpleItem|
        DevExpress.ui.dxFormGroupItem|
        DevExpress.ui.dxFormTabbedItem|
        DevExpress.ui.dxFormEmptyItem>, tabTemplate?: any, template?: any, title?: string }> {
        return this._getOption('tabs');
    }
    set tabs(value: Array<any|
        { alignItemLabels?: boolean, badge?: string, colCount?: number, colCountByScreen?: { lg?: number, md?: number, sm?: number, xs?: number }, disabled?: boolean, icon?: string, items?: Array<DevExpress.ui.dxFormSimpleItem|
        DevExpress.ui.dxFormGroupItem|
        DevExpress.ui.dxFormTabbedItem|
        DevExpress.ui.dxFormEmptyItem>, tabTemplate?: any, template?: any, title?: string }>) {
        this._setOption('tabs', value);
    }

    get badge(): string {
        return this._getOption('badge');
    }
    set badge(value: string) {
        this._setOption('badge', value);
    }

    get tabTemplate(): any {
        return this._getOption('tabTemplate');
    }
    set tabTemplate(value: any) {
        this._setOption('tabTemplate', value);
    }

    get imageAlt(): string {
        return this._getOption('imageAlt');
    }
    set imageAlt(value: string) {
        this._setOption('imageAlt', value);
    }

    get imageSrc(): string {
        return this._getOption('imageSrc');
    }
    set imageSrc(value: string) {
        this._setOption('imageSrc', value);
    }

    get key(): string {
        return this._getOption('key');
    }
    set key(value: string) {
        this._setOption('key', value);
    }

    get showChevron(): boolean {
        return this._getOption('showChevron');
    }
    set showChevron(value: boolean) {
        this._setOption('showChevron', value);
    }

    get titleTemplate(): any {
        return this._getOption('titleTemplate');
    }
    set titleTemplate(value: any) {
        this._setOption('titleTemplate', value);
    }

    get location(): string|
        Array<any|
        { col?: number, colspan?: number, row?: number, rowspan?: number, screen?: string }> {
        return this._getOption('location');
    }
    set location(value: string|
        Array<any|
        { col?: number, colspan?: number, row?: number, rowspan?: number, screen?: string }>) {
        this._setOption('location', value);
    }

    get menuTemplate(): any {
        return this._getOption('menuTemplate');
    }
    set menuTemplate(value: any) {
        this._setOption('menuTemplate', value);
    }

    get heightRatio(): number {
        return this._getOption('heightRatio');
    }
    set heightRatio(value: number) {
        this._setOption('heightRatio', value);
    }

    get widthRatio(): number {
        return this._getOption('widthRatio');
    }
    set widthRatio(value: number) {
        this._setOption('widthRatio', value);
    }

    get locateInMenu(): string {
        return this._getOption('locateInMenu');
    }
    set locateInMenu(value: string) {
        this._setOption('locateInMenu', value);
    }

    get menuItemTemplate(): any {
        return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value: any) {
        this._setOption('menuItemTemplate', value);
    }

    get options(): any {
        return this._getOption('options');
    }
    set options(value: any) {
        this._setOption('options', value);
    }

    get showText(): string {
        return this._getOption('showText');
    }
    set showText(value: string) {
        this._setOption('showText', value);
    }

    get widget(): string {
        return this._getOption('widget');
    }
    set widget(value: string) {
        this._setOption('widget', value);
    }

    get expanded(): boolean {
        return this._getOption('expanded');
    }
    set expanded(value: boolean) {
        this._setOption('expanded', value);
    }

    get hasItems(): boolean {
        return this._getOption('hasItems');
    }
    set hasItems(value: boolean) {
        this._setOption('hasItems', value);
    }

    get parentId(): number|
        string {
        return this._getOption('parentId');
    }
    set parentId(value: number|
        string) {
        this._setOption('parentId', value);
    }
}
